




























































































































































































import Vue from "vue";
import { createNamespacedHelpers } from "vuex";
import { Blog, BlogCategory, Business, Role } from "@/types";
import BlogForm from "./BlogForm.vue";

const { mapActions: blogActions, mapGetters: blogGetters } =
  createNamespacedHelpers("BLOG_");
const { mapActions: categoryActions, mapGetters: categoryGetters } =
  createNamespacedHelpers("BLOG_CATEGORY_");

const API_URL = process.env.VUE_APP_API_URL;

export default Vue.extend({
  name: "BlogList",
  components: {
    BlogForm,
  },
  data() {
    return {
      search: "",
      loading: false,
      appUrl: API_URL,
      showBlogForm: false,
      showDeleteDialog: false,
      currentBlog: null as Blog | null,
      statusFilter: null as string | null,
      categoryFilter: null as string | null,
      statusOptions: [
        { text: "Published", value: "published" },
        { text: "Draft", value: "draft" },
      ],
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
        },
        { text: "Categories", value: "categories", sortable: false },
        { text: "Created At", value: "createdAt" },
        { text: "Status", value: "status" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...blogGetters(["blogPage"]),
    ...categoryGetters(["categoryPage"]),
    role(): Role {
      return this.$store.getters.role;
    },
    blogs(): Blog[] {
      return this.blogPage?.docs || [];
    },
    categories(): BlogCategory[] {
      return this.categoryPage?.docs || [];
    },
    filteredBlogs(): Blog[] {
      let filtered = [...this.blogs];

      // Filter by status
      if (this.statusFilter) {
        filtered = filtered.filter((blog) => blog.status === this.statusFilter);
      }

      // Filter by category
      if (this.categoryFilter) {
        filtered = filtered.filter((blog) => {
          return blog.categories.some((category) => {
            if (typeof category === "string") {
              return category === this.categoryFilter;
            } else {
              return category._id === this.categoryFilter;
            }
          });
        });
      }

      return filtered;
    },
  },
  methods: {
    ...blogActions(["fetchBlogList", "deleteBlog"]),
    ...categoryActions(["fetchCategoryList"]),
    getCategoryName(category: string | BlogCategory): string {
      if (typeof category === "string") {
        const foundCategory = this.categories.find((c) => c._id === category);
        return foundCategory ? foundCategory.name : category;
      } else {
        return category.name;
      }
    },
    resetFilters() {
      this.search = "";
      this.statusFilter = null;
      this.categoryFilter = null;
    },
    fetchData() {
      if (this.role) {
        this.loading = true;
        const businessId =
          typeof this.role.business === "string"
            ? this.role.business
            : (this.role.business as Business)._id;

        this.fetchBlogList({ businessId, _status: "active" }).finally(() => {
          this.loading = false;
        });

        this.fetchCategoryList({ businessId });
      }
    },
    viewBlog(blog: Blog) {
      this.$router.push(`/blog/${blog._id}`);
    },
    editBlog(blog: Blog) {
      this.currentBlog = { ...blog };
      this.showBlogForm = true;
    },
    confirmDelete(blog: Blog) {
      this.currentBlog = blog;
      this.showDeleteDialog = true;
    },
    deleteBlogPost() {
      if (this.currentBlog && this.role) {
        const businessId =
          typeof this.role.business === "string"
            ? this.role.business
            : (this.role.business as Business)._id;

        this.deleteBlog({
          businessId,
          blogId: this.currentBlog._id,
        }).then(() => {
          this.showDeleteDialog = false;
          this.currentBlog = null;
        });
      }
    },
    closeBlogForm() {
      this.showBlogForm = false;
      this.currentBlog = null;
    },
    blogSaved() {
      this.showBlogForm = false;
      this.currentBlog = null;
      this.fetchData();
    },
    formatDate(dateString: string): string {
      if (!dateString) return "";

      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
  mounted() {
    console.log("BlogList component mounted");
    console.log("Store state BLOG_:", this.$store.state.BLOG_);
    console.log(
      "Store state BLOG_CATEGORY_:",
      this.$store.state.BLOG_CATEGORY_
    );

    if (!this.$store.state.BLOG_ || !this.$store.state.BLOG_CATEGORY_) {
      console.error("Store modules not properly registered!");
      this.$store.dispatch("setToast", {
        title: "Error",
        type: "error",
        text: "Blog modules not properly loaded. Please contact support.",
        timeout: 5000,
      });
    } else {
      this.fetchData();
    }
  },
  watch: {
    role() {
      this.fetchData();
    },
  },
});
